import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content pdt-15"
}
const _hoisted_2 = { class: "plan-details" }
const _hoisted_3 = { class: "plan-details w-100" }
const _hoisted_4 = { class: "plan-details plan-general-details flex-column align-items-start sm-pdr-10 sm-pdl-10" }
const _hoisted_5 = { class: "plan-general-header pdb-20 flex-md-nowrap sm-pdb-0 align-items-start" }
const _hoisted_6 = { class: "d-flex sm-fs-sm flex-md-row flex-column sm-gap-10" }
const _hoisted_7 = {
  key: 0,
  class: "label label_dark_green pdl-40 pdr-40 ml-15 sm-ml-0 sm-pdl-10 sm-pdr-10"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-underline plan-modal sm-fs-xxs" }, " Update ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-arrow-down plan-modal sm-fs-xxs" }, null, -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "striped small toggle" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "cell-header hide-desktop" }
const _hoisted_14 = { class: "cell-text" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("tr", { class: "parent-row" }, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "3",
    class: "cell text-center"
  }, [
    /*#__PURE__*/_createElementVNode("p", { class: "cell-header" }, "No payment destination has been set up. ")
  ])
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "account-actions" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h4", null, " Related Links ", -1)
const _hoisted_20 = { class: "action-buttons sm-pdr-0 sm-pdl-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_ProfileInfo = _resolveComponent("ProfileInfo")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ProfileInfo, {
            title: "Demographics",
            multiple: true,
            items: _ctx.demographics,
            greenItems: _ctx.spouseDetails,
            "has-divider": true,
            "use-container": true,
            alert: _ctx.isBadAddress,
            onOpenModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal('profile', 'My Profile', 'plan-profile plan-tables')))
          }, null, 8, ["items", "greenItems", "alert"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ProfileInfo, {
            title: "Pension Details",
            type: "pension",
            items: _ctx.pensionDetails,
            "has-divider": true,
            actionButton: "View/Change"
          }, null, 8, ["items"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h4", _hoisted_6, [
              _createTextVNode(" Payment Destination "),
              (_ctx.pensionStore?.pensionerDetails?.HasPaymentsOnHold)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Pension Payments on Hold - Please Call Us at 800-456-3863 "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("a", {
              class: "btn btn-primary plan-modal",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('check-destination', 'ACH/Check Destination', 'plan-form', 'pension')))
            }, _hoisted_10)
          ]),
          _createElementVNode("table", _hoisted_11, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pensionStore.paymentDestination.headers, (header, key) => {
                  return (_openBlock(), _createElementBlock("th", { key: key }, _toDisplayString(header.title), 1))
                }), 128))
              ])
            ]),
            (_ctx.pensionStore.paymentDestination.rows.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pensionStore.paymentDestination.rows, (row, mainKey) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: mainKey,
                      class: "parent-row sm-pdl-0 sm-pdr-0"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (item, key) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: key,
                          class: "cell w-sm-45"
                        }, [
                          _createElementVNode("p", _hoisted_13, _toDisplayString(key), 1),
                          _createElementVNode("p", _hoisted_14, _toDisplayString(item), 1)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_15, _hoisted_17))
          ]),
          _createElementVNode("button", {
            class: "btn btn-secondary plan-modal w-fit mt-4",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openModal('pension-payment-history', 'Pension > Pensioner Profile', 'plan-profile plan-tables pension-credits', 'pension', null, 'Payment History')), ["prevent"]))
          }, " View Payment History ")
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              class: "btn btn-secondary plan-modal",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openModal(
                    'add-beneficiary',
                    'My Beneficiary(ies)',
                    'plan-tables-striped beneficiary',
                    null,
                    null,
                    null,
                    [{ name: 'Add Beneficiary', type: 'primary', action: 'add-beneficiary', classes: 'plan-form plan-upload' }]
                )), ["prevent"]))
            }, " Beneficiary(ies) "),
            (_ctx.isPensioner)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("button", {
                    class: "btn btn-tertiary btn-large plan-modal",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModal('check-destination', 'Payment Destination Setup', 'plan-form', 'pension')))
                  }, " ACH/Check Destination"),
                  (_ctx.hasChecks)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-tertiary btn-large plan-modal",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModal('check-replacement', 'Check Replacement', 'plan-form', 'pension')))
                      }, " Check Replacement "))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("a", {
                    href: "",
                    class: "btn btn-tertiary btn-large plan-modal",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.openModal('pension-application', 'Pension Application', 'plan-form', 'application')), ["prevent"]))
                  }, "Pension Application "),
                  _createElementVNode("a", {
                    href: "",
                    class: "btn btn-tertiary btn-large plan-modal",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.openModal('pension-application', 'Estimate Request', 'plan-form', 'estimate')), ["prevent"]))
                  }, " Estimate Request ")
                ], 64)),
            _createElementVNode("a", {
              href: "",
              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.openModal('plan-resources', 'Pension Forms & Documents', null, 'pension')), ["prevent"])),
              class: "btn btn-tertiary btn-large plan-modal"
            }, "Forms & Documents ")
          ])
        ])
      ]))
}